import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DataTableComponent } from 'src/app/components/data-table/data-table.component';
import { IconModule } from 'src/app/icon/icon.module';
import { MaterialModule } from 'src/app/material.module';
import { IImportProcessError } from '../import-process-dialog/import-process-dialog.component';
import { ITableConfig } from 'src/app/shared/interfaces/ITable';

@Component({
  selector: 'app-import-process-errors',
  imports: [CommonModule, MaterialModule, TranslateModule, IconModule, DataTableComponent],
  templateUrl: './import-process-errors.component.html'
})
export class ImportProcessErrorsComponent {
  @Input() title = 'import process errors';
  @Input() errors: IImportProcessError[] = [];
  @Output() closed = new EventEmitter<void>();

  get totalErrors(): number {
    return this.errors?.length ?? 0;
  }

  tableConfig: ITableConfig = {
    disableCardStyling: true,
    columnConfig: [
      {
        title: 'sheet',
        key: 'sheet',
        cellStyle: { width: '300px', paddingLeft: '18px' },
        titleStyle: { paddingLeft: '18px' }
      },
      {
        title: 'row number',
        key: 'row',
        cellStyle: { width: '120px' }
      },
      {
        title: 'field',
        key: 'field',
        cellStyle: { width: '220px' }
      },
      {
        title: 'error',
        key: 'message',
        tooltip: true,
        cellStyle: { minWidth: '420px' }
      }
    ],
    hideHeader: false,
    hidePaginator: true
  };

  onClose() {
    this.closed.emit();
  }
}
